import React from 'react'
import clsx from 'clsx'
import Radio from '@material-ui/core/Radio'
import Paper from '@material-ui/core/Paper'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormLabel from '@material-ui/core/FormLabel'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'

export default ({
    classes,
    onChange,
    pristineData,
    value,
    label,
    name,
    options,
    helperText,
    disabled,
    inline,
    labelPlacement,
    row,
    hideLable,
    help
}) =>
    <FormControl>
        <FormLabel className={classes.formLabel}>{label}</FormLabel>
        {help && <Paper elevation={0} className={classes.helpPaper}>
                {help}
            </Paper>}
        <RadioGroup
            name={name}
            value={(value || (pristineData && pristineData[name]) || '-1')+''}
            onChange={onChange}
            className={clsx({ [classes.inline]: inline })}
            row={row}
        >
            {options.map(item =>
                <FormControlLabel
                    value={item.value}
                    control={<Radio />}
                    label={!hideLable && item.label}
                    key={item.value}
                    disabled={disabled || item.disabled}
                    labelPlacement={labelPlacement}
                />
            )}
        </RadioGroup>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl >
